import { render, staticRenderFns } from "./Configurations.vue?vue&type=template&id=26c2967b&"
import script from "./Configurations.vue?vue&type=script&lang=ts&"
export * from "./Configurations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports